import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cartSizeSelector } from 'redux/selectors/cart.selector';
import CartContainer from 'containers/CartContainer';
import './CartPopup.scss';
import { Link } from 'react-router-dom';

const CartPopup = (props) => {
    const { cartSize, } = props;

    const [isCartVisible, setCartVisible] = useState(false); 

    const toggleCart = () => {
      setCartVisible(!isCartVisible);
    }
    
    return  (
      <>
        <Link to='/carrito' className="cart-popup">
            <i className="fa fa-shopping-cart cart-popup-icon" aria-hidden="true" />
            <span id="checkout-items" className="checkout-items">
              {cartSize}
            </span>
          </Link>
          
        {/* <div className={`cart-container mobile-cart ${isCartVisible ? 'visible' : ''}`}>
          <div className='cart-card-header' onClick={toggleCart}>
            <h4 className='text-center text-carrito'>Carrito de compras</h4>
            <button className="cart-close-button" onClick={toggleCart}> X</button>
          </div>
          <div className="cart-content">
            <CartContainer isCartVisible={isCartVisible} toggleCart={toggleCart}/>
          </div>
        </div> */}
      </>
    );
};
  
  const mapStateToProps = (state) => ({
    cartSize: cartSizeSelector(state),
  });

  CartPopup.defaultProps = {
    isCartVisible: false,
  };
  
  CartPopup.propTypes = {
    cartSize: PropTypes.number,
  };
  
  export default connect(mapStateToProps)(CartPopup);